package pl.mothdigital.neuronowi.components.sections.footer

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.navigation.*
import com.varabyte.kobweb.silk.components.text.*
import com.varabyte.kobweb.silk.style.*
import com.varabyte.kobweb.silk.style.breakpoint.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.components.widgets.*
import pl.mothdigital.neuronowi.navigation.*
import pl.mothdigital.neuronowi.theme.*

val FooterStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(SiteTheme.green._900)
            .padding(topBottom = 2.cssRem, leftRight = 4.cssRem)
            .color(SiteTheme.white._900)
    }
}

@Composable
fun Footer(modifier: Modifier = Modifier) {
    Box(FooterStyle.toModifier().then(modifier), contentAlignment = Alignment.CenterStart) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            FooterTopSection()
            VerticalSpacer(1.cssRem)
            FooterDiver()
            VerticalSpacer(1.cssRem)
            Column(
                modifier = Modifier.fillMaxWidth().displayUntil(Breakpoint.MD),
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                FooterLinks()
                VerticalSpacer((0.4).cssRem)
                SpanText(
                    text = FooterResources.ALL_RIGHTS_RESERVED,
                    modifier = Modifier.color(SiteTheme.green._600).fontWeight(FontWeight.Light).fontSize(0.825.cssRem),
                )
            }
            Row(
                modifier = Modifier.fillMaxWidth().displayIfAtLeast(Breakpoint.MD),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                SpanText(
                    text = FooterResources.ALL_RIGHTS_RESERVED,
                    modifier = Modifier.color(SiteTheme.green._600).fontWeight(FontWeight.Light).fontSize(0.825.cssRem),
                )
                Spacer()
                Row(horizontalArrangement = Arrangement.spacedBy(1.cssRem)) {
                    FooterLinks()
                }
            }

        }
    }
}

@Composable
private fun NavLink(path: String, text: String, modifier: Modifier = Modifier) {
    Link(path, text, modifier = modifier, variant = UndecoratedLinkVariant.then(UncoloredLinkVariant))
}

@Composable
private fun FooterLink(path: String, text: String) {
    Span(Modifier.textAlign(TextAlign.Center).toAttrs()) {
        NavLink(
            path = path,
            text = text,
            modifier = Modifier.color(SiteTheme.green._600).fontWeight(FontWeight.Light)
                .fontSize(0.825.cssRem),
        )
    }
}

@Composable
private fun FooterLinks() {
    FooterLink(Screen.ChildProtectionStandards.route, FooterResources.CHILD_PROTECTION_STANDARDS)
    FooterLink(Screen.PrivacyPolicy.route, FooterResources.PRIVACY_POLICY_BUTTON)
    FooterLink(Screen.TermsAndConditions.route, FooterResources.TERMS_AND_CONDITIONS)
    FooterLink(Screen.Statut.route, FooterResources.STATUTE)
}
